import type {
  GroupLifeMonthlyPremium,
  GroupLifeQuoteCalculation,
} from '@/services/group-life';

const MONTHS_IN_YEAR = 12;
const toCents = (value: number) => Math.round(value * 100) / 100;

/**
 * Prêmio MENSAL do PME (total, IOF e líquido) — FONTE ÚNICA das telas (resumo
 * da cotação, proposta, análise e tarifação) e dos PDFs.
 *
 * Quem calcula é o back (`resolveGroupLifeMonthlyPremium`, publicado em
 * `calculation.monthly`): total = parcela recorrente do plano de 12x do
 * InsureMO (ou anual ÷ 12 sem parcelas), IOF = anual ÷ 12, líquido = total −
 * IOF, tudo em centavos — Líquido + IOF = Total no centavo. Antes cada tela
 * fazia a sua conta e os valores divergiam do PDF em centavos.
 *
 * A reserva abaixo repete a regra do back só para respostas sem `monthly`
 * (back anterior à mudança); não é outra regra.
 */
export function resolveGroupLifeMonthlyPremium(
  calculation: GroupLifeQuoteCalculation | undefined | null
): GroupLifeMonthlyPremium | null {
  if (!calculation) return null;
  if (calculation.monthly) return calculation.monthly;

  const annualTotal = calculation.totalPremium ?? 0;
  const installment = calculation.monthlyPremium ?? 0;
  if (installment <= 0 && annualTotal <= 0) return null;

  const total = toCents(
    installment > 0 ? installment : annualTotal / MONTHS_IN_YEAR
  );
  const iof = toCents((calculation.iof ?? 0) / MONTHS_IN_YEAR);
  return {
    total,
    iof,
    beforeIof: toCents(Math.max(total - iof, 0)),
    source: installment > 0 ? 'INSTALLMENT' : 'ANNUAL_DIVIDED',
  };
}
